import fetch from "../fetch";
import pickBy from "lodash/pickBy";

export default ({ params = {}, dealCode, trancheId } = {}) =>
  fetch({
    path: `/cmbs/deals/${dealCode}/tranche-prices/${trancheId}/tranche-ratings`,
    params: pickBy(params)
  });
